import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

export interface Language {
    name: string;
    code: string;
}

@Injectable({
    providedIn: 'root'
})
export class LanguageService {
    private languages: Language[] = [
        {name: 'English', code: 'en'},
        {name: 'Deutsch', code: 'de'}
    ];
    private currentLanguage: string;

    constructor(private translate: TranslateService) {
        this.currentLanguage = this.detectBrowserLanguage();
        translate.setDefaultLang(this.currentLanguage);
        translate.use(this.currentLanguage);
    }

    getLanguages(): Language[] {
        return this.languages;
    }

    changeLanguage(lang: string) {
        this.currentLanguage = lang;
        localStorage.setItem('selectedLanguage', lang);
        console.log("Selected language is " + lang);
        this.translate.use(lang);
    }

    getCurrentLanguage(): Language {
        return this.languages.find(language => language.code === this.currentLanguage) || this.languages[0];
    }

    private detectBrowserLanguage(): string {

        const browserLang = navigator.language || (navigator as any)['userLanguage'];
        const lang = browserLang.split('-')[0];

        if (this.languages.some(language => language.code === lang)) {
            return lang;
        } else {
            return 'en';
        }
    }

}
